import { StatsCtaPropertyStore } from 'common/module/stats-cta-property/store';
import { StatsService } from 'common/service/stats/service';
import { StatsTealiumProviderService } from 'common/service/stats-tealium-provider/service';

const service = new StatsCtaPropertyStore(StatsService(), StatsTealiumProviderService());

export const StatsCtaPropertyService = () => service;
